import { createSafeRegExp } from '../tools/basic-functions.js';

export async function initFaqList() {
  let jsonURL = '/' + _CMS_LANGUAGE + '/json/faq';
  const moduleBasicFunc = await import('../tools/basic-functions.js'),
    faqData = await moduleBasicFunc.getJSON(jsonURL),
    groupBy = (key) => (array) =>
      array.reduce((objectsByKeyValue, obj) => {
        const value = obj[key];
        objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
        return objectsByKeyValue;
      }, {}),
    groupByCategory = groupBy('category'),
    faqDataGroupedByCategory = groupByCategory(faqData.faqs),
    faqDataOnlyHighlited = faqData.faqs.filter((x) => x.is_highlighted == 1);
  let faqContentContainer = document.querySelector('.js-faq-content'),
    faqTitleEl = document.querySelector('.js-support-faq-title');
  initStartFaqList(faqDataGroupedByCategory, faqContentContainer, faqTitleEl);
  initFaqsHighlighted(faqDataOnlyHighlited, faqContentContainer, faqTitleEl, moduleBasicFunc.createEl);
  initFaqCategoriesList(faqDataGroupedByCategory, faqContentContainer, faqTitleEl, moduleBasicFunc.createEl);
  initFaqSearch(faqData.faqs, faqDataGroupedByCategory, faqContentContainer, faqTitleEl);
}

function initStartFaqList(faqDataGroupedByCategory, faqContentContainer, faqTitleEl) {
  let firstCategory = faqDataGroupedByCategory[Object.keys(faqDataGroupedByCategory)[0]];
  faqContentContainer.innerHTML = '';
  faqTitleEl.innerHTML = firstCategory[0].category;
  for (let i = 0, len = firstCategory.length; i < len; i++) {
    faqContentContainer.innerHTML += decodeHTML(
      '<p class="title title-s">' +
        firstCategory[i].name +
        '</p><div class="support-faq-content-inner">' +
        firstCategory[i].body +
        '</div>'
    );
  }
}

function initFaqCategoriesList(faqDataGroupedByCategory, faqContentContainer, faqTitleEl, createEl) {
  let categoriesListContainer = document.querySelector('.js-category-list');
  for (let key of Object.keys(faqDataGroupedByCategory)) {
    let faqCategoryPanel = createEl('<a class="topic-name active">' + key + '</a>');
    categoriesListContainer.appendChild(faqCategoryPanel);
    faqCategoryPanel.addEventListener('click', () => {
      let categoryFaqsList = faqDataGroupedByCategory[key];
      faqContentContainer.innerHTML = '';
      faqTitleEl.innerHTML = categoryFaqsList[0].category;
      for (let i = 0, len = categoryFaqsList.length; i < len; i++) {
        faqContentContainer.innerHTML += decodeHTML(
          '<p class="title title-s">' +
            categoryFaqsList[i].name +
            '</p><div class="support-faq-content-inner">' +
            categoryFaqsList[i].body +
            '</div>'
        );
      }
      if (document.querySelector('body').getAttribute('data-device') == 'mobile') {
        scroll({
          top: document.querySelector('.js-faq-content').offsetTop - 100,
          behavior: 'smooth'
        });
      }
    });
  }

  //TODO translations,
}

function initFaqsHighlighted(faqs, faqContentContainer, faqTitleEl, createEl) {
  let highlightedListContainer = document.querySelector('.js-highlighted-list');
  for (let i = 0, len = faqs.length; i < len; i++) {
    let highlightedFaqEl = createEl('<a class="faq-highlighted-box">' + faqs[i].name + '</a>');
    highlightedListContainer.appendChild(highlightedFaqEl);
    highlightedFaqEl.addEventListener('click', () => {
      faqContentContainer.innerHTML = decodeHTML(
        '<p class="title title-s">' +
          faqs[i].name +
          '</p><div class="support-faq-content-inner">' +
          faqs[i].body +
          '</div>'
      );
      faqTitleEl.innerHTML = faqs[i].category;
      if (document.querySelector('body').getAttribute('data-device') == 'mobile') {
        scroll({
          top: document.querySelector('.js-faq-content').offsetTop - 100,
          behavior: 'smooth'
        });
      }
    });
  }
}

export function initFaqSearch(faqData, faqDataGroupedByCategory, faqContentContainer, faqTitleEl) {
  let searchInput = document.querySelector('.js-faq-search-input');
  searchInput.addEventListener('input', (e) => {
    let searchInputValue = e.target.value;
    searchInputValue = searchInputValue
      .toLowerCase()
      .replace(/[\*\^\'\!\:]/g, '')
      .split(' ')
      .join('-');
    faqContentContainer.innerHTML = '';
    faqTitleEl.innerHTML = '';
    if (searchInputValue.length > 0) {
      document.querySelector('.support-faq').classList.add('d-none');
      if (document.querySelector('body').getAttribute('data-device') == 'mobile') {
        document.querySelector('.support-topics').classList.add('d-none');
      }
      for (let i = 0, len = faqData.length; i < len; i++) {
        if (
          faqData[i].name
            .toLowerCase()
            .replace(/[\*\^\'\!\™\:]/g, '')
            .split(' ')
            .join('-')
            .search(createSafeRegExp(searchInputValue)) > -1
        ) {
          faqContentContainer.innerHTML += decodeHTML(
            '<p class="title title-s">' +
              faqData[i].name +
              '</p><div class="support-faq-content-inner">' +
              faqData[i].body +
              '</div>'
          );
        }
      }
    } else {
      document.querySelector('.support-faq').classList.remove('d-none');
      if (document.querySelector('body').getAttribute('data-device') == 'mobile') {
        document.querySelector('.support-topics').classList.remove('d-none');
      }
      initStartFaqList(faqDataGroupedByCategory, faqContentContainer, faqTitleEl);
    }
  });
}

function decodeHTML(html) {
  let temp = document.createElement('textarea');
  temp.innerHTML = html;
  return temp.value;
}
